import { render } from "./Push.vue?vue&type=template&id=821c05be&scoped=true&ts=true"
import script from "./Push.vue?vue&type=script&lang=ts"
export * from "./Push.vue?vue&type=script&lang=ts"

import "./Push.vue?vue&type=style&index=0&id=821c05be&scoped=true&lang=less"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-821c05be"]])

export default __exports__